/**
 * Configuration for Fill in the Blanks prompt forms.
 * Each question type defines its own set of preset buttons.
 * Bulk-generate field configs are registered into the common registry.
 */

import type { PresetButton } from '../types';
import type { BulkFormConfig } from '../bulk-config';
import { MEDIA_FIELD, NUM_BLANKS_FIELD, registerBulkFormConfigs } from '../bulk-config';
import type { FillInTheBlanksFormState } from './types';

// ---------------------------------------------------------------------------
// Bulk-generate configs for Fill in the Blanks slugs
// ---------------------------------------------------------------------------

const DEFAULT_BULK_CONFIG: BulkFormConfig = {
    fields: [MEDIA_FIELD, NUM_BLANKS_FIELD],
};

registerBulkFormConfigs({
    'gap_typing': DEFAULT_BULK_CONFIG,
});

const TOPIC_PRESET =
    'Tạo câu hỏi về chủ đề [chủ đề], thuộc môn học [môn học], trình độ [level], dành cho đối tượng [đối tượng]';
const DOCUMENT_PRESET =
    'Dựa trên nội dung trong file đính kèm của tôi, hãy tạo câu hỏi thuộc môn học [môn học], trình độ [level], dành cho đối tượng [đối tượng]';

const DEFAULT_PRESETS: PresetButton[] = [
    { key: 'topic', value: TOPIC_PRESET, label: 'Tạo theo chủ đề', icon: 'BookOpen' },
    { key: 'document', value: DOCUMENT_PRESET, label: 'Tạo từ tài liệu', icon: 'FileText' },
];

export const QUESTION_TYPE_PRESETS: Record<string, PresetButton[]> = {
    'gap_typing': DEFAULT_PRESETS,
};

export interface QuickCreateTemplate {
    slug: string;
    defaults: FillInTheBlanksFormState;
}

// WHY: Only canonical Dropdown AI slug — subtype templates (qt-dropdown, …)
// were never registered in FORM_SLUG_MAPPING and left dead state.
export const QUICK_CREATE_TEMPLATES: QuickCreateTemplate[] = [
    {
        slug: 'gap_typing',
        defaults: {
            media: 'none',
            num_blanks: 1,
            sourceType: 'topic',
            description: '',
            documents: [],
        },
    },
];
